import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/css';
import { windowWidth } from './utils';

const sliders = {
  init() {
    this.topBar();
    this.heroSlider();
    this.prodSlider();
    this.textSlider();
    this.testimonialsSlider();
    this.blogs();
    this.catSlider();
    this.setProdThumbnailsSlider();
    this.resetSlider();
  },

  resetSlider() {
    window.addEventListener('reset', () => {
      this.setProdThumbnailsSlider();
    });
  },

  topBar() {
    const sliders = document.querySelectorAll(
      '.jsTopSlide',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        perPage: 1,
        arrows: true,
        autoplay: true,
        speed: 800,
      }).mount();
    });
  },

  heroSlider() {
    const sliders = document.querySelectorAll(
      '.jsHeroSlider',
    ) as NodeListOf<HTMLElement>;
    sliders.forEach((el) => {
      const slider = new Splide(el, {
        type: 'loop',
        perPage: 1,
        pagination: true,
        arrows: true,
        autoplay: true,
        speed: 800,
      });

      slider.mount();
    });
  },

  catSlider() {
    const sliders = document.querySelectorAll(
      '.jsCatSlider',
    ) as NodeListOf<HTMLElement>;
    sliders.forEach((el) => {
      const slider = new Splide(el, {
        type: 'loop',
        perPage: 6,
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 800,
        gap: 15,
        destroy: false,
        breakpoints: {
          1199: {
            destroy: true,
          },
        },
      });

      slider.mount();
    });
  },

  testimonialsSlider() {
    const sliders = document.querySelectorAll(
      '.jsTestimonialsSlider',
    ) as NodeListOf<HTMLElement>;
    sliders.forEach((el) => {
      const slider = new Splide(el, {
        type: 'loop',
        perPage: 1,
        pagination: true,
        arrows: false,
        autoplay: true,
        speed: 800,
      });

      slider.mount();
    });
  },

  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: false,
        arrows: true,
        perPage: 5,
        breakpoints: {
          768: {
            perPage: 2,
            padding: { right: '30%' },
          },
          460: {
            perPage: 1,
            padding: { right: '30%' },
          },
        },
      }).mount();
    });
  },

  textSlider() {
    const sliders = document.querySelectorAll(
      '.jsTextSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        perPage: 4,
        pagination: false,
        arrows: false,
        gap: 30,
        autoScroll: {
          speed: -1,
        },
        breakpoints: {
          768: {
            perPage: 3,
            gap: 15,
          },
          500: {
            perPage: 1,
            padding: { right: '30%' },
          },
        },
      }).mount({ AutoScroll });
    });
  },

  blogs() {
    const slider = document.querySelectorAll(
      '.jsBlogs',
    ) as NodeListOf<HTMLElement>;

    slider.forEach((item) => {
      new Splide(item, {
        perPage: 3,
        type: 'loop',
        pagination: false,
        arrows: false,
        gap: '25px',
        breakpoints: {
          1200: {
            gap: '10px',
            perPage: 2,
            padding: { right: '30%' },
          },

          768: {
            padding: { right: '0' },
            perPage: 1,
          },
        },
      }).mount();
    });
  },

  setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById('mainImage') as
      | HTMLElement
      | undefined;
    const thumbnails = document.getElementById('thumbnails') as
      | HTMLElement
      | undefined;

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
      });

      const thumbnailsNav = new Splide(thumbnails, {
        direction: 'ttb',
        isNavigation: true,
        pagination: false,
        heightRatio: 5,
        perPage: 4,
        arrows: true,
        gap: '18px',
      });

      main.sync(thumbnailsNav);
      main.mount();
      thumbnailsNav.mount();
    }
  },
};

export default sliders;
